// Donor detail page (CHG-1225 / ITER-3347).
//
// Thin per .forge/plans/v2-canary-pages.md §6: page files ≤50 LOC, all
// configuration in @generated/screens. Future generator regenerates
// donorDetailConfig from donor.entity-hint.yaml without touching this
// file.
//
// Spec: specs/tier-05-experience/donor-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { donorDetailConfig } from "../generated/screens/donor-detail";

export function DonorDetail() {
  return <DetailPage config={donorDetailConfig} />;
}
